<template>
  <v-app>
    <v-app-bar app color="#E3002C" dark clipped-left>
      <v-app-bar-nav-icon @click="toggleDrawer" />
      <div class="d-flex align-center">
        <v-img
          alt="Limagrain Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/logo.png')"
          transition="scale-transition"
          width="40"
        />
        <v-img
          alt="Clon Logo"
          class="shrink hidden-sm-and-down"
          contain
          min-width="100"
          :src="require('./assets/logoClon.png')"
          width="100"
        />
      </div>
      <v-spacer></v-spacer>
      <!-- Account Receivable Movements -->
      <v-btn
        :key="log_events + 100"
        text
        @click="navigateToUnseenAccountReceivableMovements"
        v-if="
          $bRoot.auth.loggedIn &&
            ($route.name !== 'Login' ? true : false) &&
            $bRoot.auth.show_comunication === true
        "
      >
        <v-badge
          overlap
          color="green"
          :content="
            String($bRoot.auth.unseen_account_receivable_movements || 0)
          "
        >
          <v-icon left class="pa-4"
            >{{
              ($bRoot.auth.unseen_account_receivable_movements || 0) === 0
                ? "mdi-checkbook"
                : "mdi-checkbook-arrow-left"
            }}
          </v-icon>
        </v-badge>
      </v-btn>
      <!-- Comunications -->
      <v-btn
        :key="log_events"
        text
        @click="Comunications"
        v-if="
          $bRoot.auth.loggedIn &&
            ($route.name !== 'Login' ? true : false) &&
            $bRoot.auth.show_comunication === true
        "
      >
        <v-badge
          overlap
          color="green"
          :content="String($bRoot.auth.unreaded_comunications)"
        >
          <v-icon
            no-action
            @click="navigateToPath('comunicationViewer')"
            left
            class="pa-4"
            >{{
              $bRoot.auth.unreaded_comunications === 0
                ? "mdi-bell-outline"
                : "mdi-bell-ring-outline"
            }}
          </v-icon>
        </v-badge>
      </v-btn>
      <!-- LogOut -->
      <v-btn
        :key="log_events + 1"
        text
        @click="LogOut"
        v-if="$bRoot.auth.loggedIn && ($route.name !== 'Login' ? true : false)"
      >
        Cerrar sesión
        <v-icon right>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      app
      v-if="
        ($bRoot.appInfo ? true : false) &&
          !$bRoot.auth.avoid_navigation === true
      "
      :key="$route.path"
      clipped
      v-model="drawer"
    >
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ $bRoot.appInfo ? $bRoot.appInfo.last_name : null }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{
                $bRoot.appInfo
                  ? $bRoot.appInfo.commercial_person.commercial_person_type
                      .description
                  : null
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-group
          v-for="item in $bRoot.appInfo
            ? $bRoot.appInfo.enabled_menu_items
            : []"
          :key="item.code"
          :append-icon="item.component ? null : '$expand'"
        >
          <v-list-item
            slot="activator"
            @click.stop="item.component ? navigateTo(item) : ''"
          >
            <v-list-item-content>
              {{ item.description }}
            </v-list-item-content>
          </v-list-item>
          <template v-for="subItem in item.sub_item">
            <v-list-group
              no-action
              :key="subItem.code"
              @click="navigateTo(subItem)"
              append-icon=""
            >
              <template slot="activator">
                <v-list-item>
                  <v-list-item-content class="pl-4">
                    {{ subItem.description }}
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list-group>
      </v-list>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>V01.052 08-09-2026</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="supportMailToClipBoard()">
          <v-list-item-content>
            <v-list-item-subtitle>
              soporte.clon@limagrain.com
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>mdi-content-copy</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main app>
      <v-container fluid>
        <router-view :key="$route.path"></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {
    //
  },

  data: () => ({
    drawer: false,
    log_events: 0
  }),

  watch: {
    drawer: {
      handler(val) {
        this.$bRoot.setDrawer(val);
      }
    },
    deep: true
  },

  methods: {
    async LogOut() {
      try {
        await this.$bRoot.auth.logout();
        if (this.$bRoot.errors) {
          alert(this.$bRoot.errors);
        }
      } catch (err) {
        alert(`Error: ${err}`);
      } finally {
        window.location.assign(this.$bRoot.CLI_SERVER);
      }
    },
    Comunications() {
      //Todo
    },
    async onError(error, reload) {
      await this.$confirm(error);
      if (reload) {
        window.location.assign(this.$bRoot.CLI_SERVER);
      }
    },

    toggleDrawer() {
      this.$bRoot.toggleDrawer();
    },

    navigateToPath(path) {
      this.$bRoot.toggleDrawer();
      if (this.$router.currentRoute.name !== path) {
        this.$router.push({ name: path });
      }
    },

    navigateToUnseenAccountReceivableMovements() {
      this.$bRoot.toggleDrawer();
      this.$router.push({
        name: "ClientCurrentAccountMovements",
        params: {
          days_from: this.$bRoot.ACCOUNT_RECEIVABLE_MOVEMENTS_DEFAULT_DAYS.toString(),
          unseen_only: "1"
        }
      });
    },

    navigateTo(item) {
      this.$bRoot.toggleDrawer();
      if (this.$router.currentRoute.name !== item.component) {
        this.$router.push({ name: item.component, params: item.params });
      }
    },

    drawerChanged() {
      this.drawer = this.$bRoot.drawer;
    },

    async supportMailToClipBoard() {
      try {
        await navigator.clipboard.writeText("soporte.clon@limagrain.com");
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    },

    async logEvent() {
      this.log_events += 1;
      if (!this.$bRoot.auth.avoid_navigation && !this.$bRoot.drawer) {
        this.$bRoot.toggleDrawer();
      }
    },

    repaintEvent() {
      this.log_events += 1;
    }
  },

  created() {
    this.$bRoot.eventHub.$on("error", this.onError);
    this.$bRoot.eventHub.$on("drawerChanged", this.drawerChanged);
    this.$bRoot.eventHub.$on("logIn", this.logEvent);
    this.$bRoot.eventHub.$on("repaint", this.repaintEvent);

    this.$bRoot.eventHub.$on("passwordExpiryWarning", days => {
      this.$confirm(
        `Su contraseña vencerá en ${days} días. Por favor cambiela pronto.`
      );
    });

    this.$bRoot.eventHub.$on("passwordExpired", async () => {
      try {
        this.$confirm(`Su contraseña expiró y debe cambiarla.`);
        await this.$router.push({
          name: "Register",
          params: { mode: "changePassword" }
        });
      } catch (error) {
        console.error("Error redirigiendo a cambio de contraseña:", error);
        window.location.href = "/register?mode=changePassword&expired=true";
      }
    });
  },

  beforeDestroy() {
    this.$bRoot.eventHub.$off("error");
    this.$bRoot.eventHub.$off("drawerChanged");
    this.$bRoot.eventHub.$off("repaint");
  }
};
</script>
<style scoped>
.home {
  background: url("~@/assets/home_landscape.jpg") !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  width: 100% !important;
  height: 100% !important;
  background-color: rgb(0, 0, 0, 0);
}
</style>
